import { ReactComponent as TriangleUp } from './svg/triangleUp.svg'

export default TriangleUp
